var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiveStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 59,
    viewBox: "0 0 113 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72481 34.083L3.60146 37.4402L5.21111 31.5302L0.435059 27.695L6.55323 27.3995L8.72481 21.6721L10.8964 27.3995L17.0146 27.695L12.2385 31.5302L13.8482 37.4402L8.72481 34.083Z",
    fill: "#FFC54F"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_13_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1748 34.083L26.0514 37.4402L27.6611 31.5302L22.885 27.695L29.0032 27.3995L31.1748 21.6721L33.3464 27.3995L39.4645 27.695L34.6885 31.5302L36.2981 37.4402L31.1748 34.083Z",
    fill: "#FFC54F"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_13_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6347 34.083L48.5114 37.4402L50.121 31.5302L45.345 27.695L51.4631 27.3995L53.6347 21.6721L55.8063 27.3995L61.9245 27.695L57.1484 31.5302L58.7581 37.4402L53.6347 34.083Z",
    fill: "#FFC54F"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_13_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0849 34.083L70.9616 37.4402L72.5712 31.5302L67.7952 27.695L73.9133 27.3995L76.0849 21.6721L78.2565 27.3995L84.3747 27.695L79.5986 31.5302L81.2083 37.4402L76.0849 34.083Z",
    fill: "#FFC54F"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_13_149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_13_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5349 34.083L93.4115 37.4402L95.0212 31.5302L90.2451 27.695L96.3633 27.3995L98.5349 21.6721L100.706 27.3995L106.825 27.695L102.049 31.5302L103.658 37.4402L98.5349 34.083Z",
    fill: "#FFC54F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(0 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(0 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4327,
    height: 15.98,
    fill: "white",
    transform: "translate(0.00854492 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(22.45 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(22.45 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4327,
    height: 15.98,
    fill: "white",
    transform: "translate(22.4585 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(44.9099 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(44.9099 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4327,
    height: 15.98,
    fill: "white",
    transform: "translate(44.9185 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(67.3601 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(67.3601 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4327,
    height: 15.98,
    fill: "white",
    transform: "translate(67.3687 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(89.8101 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.45,
    height: 15.98,
    fill: "white",
    transform: "translate(89.8101 21.6721)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_13_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4327,
    height: 15.98,
    fill: "white",
    transform: "translate(89.8186 21.6721)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStars);
export default __webpack_public_path__ + "static/media/five-stars.7ee051da5da43542b90317b75e3ff4ef.svg";
export { ForwardRef as ReactComponent };